import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import {
  loadUnapprovedTargetGroups,
  approveTargetGroup,
  rejectTargetGroup
} from "../../redux/actions/targetGroupActions";
import {
  loadUnapprovedCategories,
  approveCategory,
  rejectCategory
} from "../../redux/actions/categoryActions";

export default function AdminApproval() {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const [categoryApprovalList, setCategoryApprovalList] = useState([]);
  const [targetGroupApprovalList, setTargetGroupApprovalList] = useState([]);

  useEffect(() => {
    getUnapprovedTargetGroups();
    getUnapprovedCategories();
  }, []);

  const getUnapprovedTargetGroups = async () => {
    const accessToken = await getAccessTokenSilently();
    const targetGroups = await dispatch(
      loadUnapprovedTargetGroups(accessToken)
    );
    if (targetGroups) {
      const list = targetGroups.map(targetgroup => (
        <li className="approval-item" key={targetgroup}>
          <span className="event-link">{targetgroup}</span>
          <input
            className="approve"
            type="submit"
            id={targetgroup}
            onClick={handleApproveTargetGroup}
            value="Godkänn"
          />
          <input
            className="remove"
            type="submit"
            id={targetgroup}
            onClick={handleRejectTargetGroup}
            value="Ta bort"
          />
        </li>
      ));
      setTargetGroupApprovalList(list);
    }
    console.log("targetgroups: ", targetGroups);
  };

  const getUnapprovedCategories = async () => {
    const accessToken = await getAccessTokenSilently();
    const categories = await dispatch(loadUnapprovedCategories(accessToken));
    if (categories) {
      const list = categories.map(category => (
        <li className="approval-item" key={category}>
          <span className="event-link">{category}</span>
          <input
            className="approve"
            type="submit"
            id={category}
            onClick={handleApproveCategory}
            value="Godkänn"
          />
          <input
            className="remove"
            type="submit"
            id={category}
            onClick={handleRejectCategory}
            value="Ta bort"
          />
        </li>
      ));
      setCategoryApprovalList(list);
    }
    console.log("categories: ", categories);
  };

  const handleApproveTargetGroup = async e => {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(approveTargetGroup(accessToken, e.target.id));
  };

  const handleApproveCategory = async e => {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(approveCategory(accessToken,e.target.id));
  };

  const handleRejectTargetGroup = async e => {
    e.preventDefault();
    if (window.confirm("Vill du ta bort " + e.target.id + " från databasen?")) {
      console.log("delete id : " + e.target.id);
      const accessToken = await getAccessTokenSilently();
      dispatch(rejectTargetGroup(accessToken,e.target.id));
    } else {
      console.log("cancel");
    }
  };

  const handleRejectCategory = async e => {
    e.preventDefault();
    if (window.confirm("Vill du ta bort " + e.target.id + " från databasen?")) {
      console.log("delete id : " + e.target.id);
      const accessToken = await getAccessTokenSilently();
      dispatch(rejectCategory(accessToken, e.target.id));
    } else {
      console.log("cancel");
    }
  };

  return (
    <div className="approval-lists">
      {targetGroupApprovalList.length !== 0 ||
      categoryApprovalList.length !== 0 ? (
        <span>Här är något som du behöver ta ställning till: </span>
      ) : (
        <></>
      )}
      <br></br>
      <br></br>
      {targetGroupApprovalList.length !== 0 && (
        <div>
          <span>Målgrupp</span>
          <div className="approval-list">{targetGroupApprovalList}</div>
        </div>
      )}
      {categoryApprovalList.length !== 0 && (
        <div>
          <span>Kategori</span>
          <div className="approval-list">{categoryApprovalList}</div>
        </div>
      )}
    </div>
  );
}
